var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form",
    {
      ref: "loginForm",
      staticClass: "login-form",
      attrs: {
        "status-icon": "",
        rules: _vm.loginRules,
        size: "medium",
        model: _vm.loginForm,
        "label-width": "0",
      },
    },
    [
      _vm.tenantMode
        ? _c(
            "el-form-item",
            { attrs: { prop: "tenantId" } },
            [
              _c(
                "el-input",
                {
                  attrs: {
                    "auto-complete": "off",
                    placeholder: _vm.$t("login.tenantId"),
                  },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.handleLogin.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.loginForm.tenantId,
                    callback: function ($$v) {
                      _vm.$set(_vm.loginForm, "tenantId", $$v)
                    },
                    expression: "loginForm.tenantId",
                  },
                },
                [
                  _c("i", {
                    staticClass: "icon-quanxian",
                    attrs: { slot: "prefix" },
                    slot: "prefix",
                  }),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-form-item",
        { attrs: { prop: "username" } },
        [
          _c(
            "el-input",
            {
              attrs: {
                "auto-complete": "off",
                placeholder: _vm.$t("login.username"),
              },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.handleLogin.apply(null, arguments)
                },
              },
              model: {
                value: _vm.loginForm.username,
                callback: function ($$v) {
                  _vm.$set(_vm.loginForm, "username", $$v)
                },
                expression: "loginForm.username",
              },
            },
            [
              _c("i", {
                staticClass: "icon-yonghu",
                attrs: { slot: "prefix" },
                slot: "prefix",
              }),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { prop: "password" } },
        [
          _c(
            "el-input",
            {
              attrs: {
                type: _vm.passwordType,
                "auto-complete": "off",
                placeholder: _vm.$t("login.password"),
              },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.handleLogin.apply(null, arguments)
                },
              },
              model: {
                value: _vm.loginForm.password,
                callback: function ($$v) {
                  _vm.$set(_vm.loginForm, "password", $$v)
                },
                expression: "loginForm.password",
              },
            },
            [
              _c("i", {
                staticClass: "el-icon-view el-input__icon",
                attrs: { slot: "suffix" },
                on: { click: _vm.showPassword },
                slot: "suffix",
              }),
              _c("i", {
                staticClass: "icon-mima",
                attrs: { slot: "prefix" },
                slot: "prefix",
              }),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        [
          _c(
            "el-button",
            {
              staticClass: "login-submit",
              attrs: { type: "primary" },
              nativeOn: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.handleLogin.apply(null, arguments)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("login.submit")))]
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        [
          _c(
            "el-button",
            {
              staticClass: "login-submit legacy-migration-submit",
              attrs: { type: "warning" },
              nativeOn: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.handleLegacyMigration.apply(null, arguments)
                },
              },
            },
            [_vm._v("\n      登录并进入新后台\n    ")]
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        [_c("el-divider", [_vm._v(_vm._s(_vm.$t("login.otherLogin")))])],
        1
      ),
      _c("el-form-item", [
        _c(
          "div",
          { staticClass: "other-login" },
          [
            _c("img", {
              staticStyle: {
                width: "36px",
                cursor: "pointer",
                "border-radius": "18px",
              },
              attrs: { src: require("@/assets/icon/feishu-icon.png") },
              on: { click: _vm.feishuLogin },
            }),
            _c(
              "el-popover",
              {
                attrs: {
                  placement: "top",
                  title: " ",
                  width: "300",
                  trigger: "hover",
                },
                on: { show: _vm.handlePopoverShow },
              },
              [
                _c("div", {
                  staticStyle: { width: "300px", height: "300px" },
                  attrs: { id: "qr_code_container" },
                }),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "center",
                      "margin-top": "10px",
                    },
                  },
                  [_vm._v("请使用飞书app扫码登录")]
                ),
                _c("div", { attrs: { slot: "reference" }, slot: "reference" }, [
                  _c("img", {
                    staticStyle: {
                      "margin-left": "10px",
                      width: "36px",
                      cursor: "pointer",
                    },
                    attrs: { src: require("@/assets/icon/qr-code-icon.png") },
                  }),
                ]),
              ]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }